import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowRight, Chrome, Mail } from 'lucide-react';
import { AuthFrame } from '../../components/AuthFrame';
import { requireSupabase } from '../../lib/supabase';

export function LoginPage() {
  const [params] = useSearchParams();
  const redirect = params.get('redirect') || '/hub';
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault(); setBusy(true); setError('');
    const { error: authError } = await requireSupabase().auth.signInWithPassword({ email, password });
    setBusy(false);
    if (authError) return setError(authError.message);
    navigate(redirect, { replace: true });
  };

  const google = async () => {
    setError('');
    const safeRedirect = redirect.startsWith('/hub') ? redirect : '/hub';
    const callback = `${window.location.origin}${safeRedirect}`;
    const { error: authError } = await requireSupabase().auth.signInWithOAuth({ provider: 'google', options: { redirectTo: callback } });
    if (authError) setError(authError.message);
  };

  const magicLink = async () => {
    if (!email) return setError('Enter your email first.');
    setBusy(true); setError('');
    const { error: authError } = await requireSupabase().auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${window.location.origin}${redirect}` },
    });
    setBusy(false);
    if (authError) setError(authError.message);
    else setError('Magic link sent. Check your email.');
  };

  return (
    <AuthFrame eyebrow="Member access" title="Return to your rebuild" description="Sign in to continue where you left off." footer={<p>New here? <Link to="/hub/signup">Create your account</Link></p>}>
      <form className="auth-form" onSubmit={submit}>
        <label>Email<input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label>Password<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {error && <div className={`form-message ${error.startsWith('Magic') ? 'success' : ''}`}>{error}</div>}
        <button className="button primary full" disabled={busy}>{busy ? 'Signing in…' : <>Sign in <ArrowRight size={17} /></>}</button>
        <button type="button" className="button secondary full" onClick={magicLink}><Mail size={17} /> Email me a magic link</button>
        <button type="button" className="button secondary full" onClick={google}><Chrome size={17} /> Continue with Google</button>
        <div className="auth-inline"><Link to="/hub/forgot-password">Forgot your password?</Link></div>
      </form>
    </AuthFrame>
  );
}
